export default __webpack_public_path__ + "static/media/3.aa8a5a3e.png";